import { useState } from 'react'

export const useMenu = () => {
    const [pin, setPin] = useState('');
    
    const handlePinChange = (e) => {
        const value = e.target.value
        
        if (!/^\d*$/.test(value)) {
            return
        }
        
        if (value.length <= 4) {
            setPin(value)
        }
    }

    return {
        pin,
        handlePinChange,
    }
}

export default useMenu;